var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFileSaved = function SvgFileSaved(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.547 10.75h-1.374a9.065 9.065 0 0 0-2.434-4.27 8.639 8.639 0 0 0-4.255-2.295 8.473 8.473 0 0 0-4.788.375 8.747 8.747 0 0 0-3.87 2.931 9.16 9.16 0 0 0-1.781 4.6 9.247 9.247 0 0 0 .848 4.876 8.908 8.908 0 0 0 3.221 3.674A8.528 8.528 0 0 0 9.731 22h9.816a5.37 5.37 0 0 0 3.856-1.648A5.716 5.716 0 0 0 25 16.375a5.716 5.716 0 0 0-1.597-3.977 5.37 5.37 0 0 0-3.856-1.648Z",
    stroke: "#8B8C8E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14 11-5.625 5L6 13.5",
    stroke: "#8B8C8E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFileSaved;